import React from 'react';
import styled from 'styled-components';
import { Wrapper } from './style';
import { withModifiers } from 'utils/styles';
import { ReactComponent as TailSVG } from './icons/tail.svg';
//import { ReactComponent as EditorIcon } from "styles/icons/highlight.svg";
import { SnippetName } from 'components/pspdf/components/snippet-name-editor/components/snippet-name-form';

export const DecorationAnnotation = styled.div.attrs({
  className: 'Cortlex-Annotation',
})`
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: absolute;
  top: 0;

  ${withModifiers('highlight')`
    background-color: #DCAA4F;
    opacity: 0.3;
  `}

  ${withModifiers('underline')`
    border-bottom: 2px solid #F36264;
  `}
  
  ${withModifiers('strikethrough')`
    border-bottom: 2px solid #F36264;
    top: calc(-50% + 2px);
  `}
  
  ${withModifiers('$link')`
    background-color: rgba(95, 95, 95, 0.1);
    height: 100%;
  `}
  
  ${withModifiers('$name')`
    background-color: rgba(95, 95, 95, 0.1);
    height: 100%;
  `}
`;

export const DecorationContainer = styled.div`
  position: absolute;
  top: ${({ rect, parentRect }) => rect.top - parentRect.top}px;
  left: ${({ rect, parentRect }) => rect.left - parentRect.left}px;
  width: ${({ rect }) => rect.width}px;
  height: ${({ rect }) => rect.height}px;
`;

function DecorationAnnotations({ annotation }) {
  const { rects, boundingBox } = annotation;
  const decorations = annotation.customData.decorations || [];

  return rects.map((rect) => (
    <DecorationContainer rect={rect} parentRect={boundingBox}>
      {decorations.map((decoration) => {
        const props = {
          key: decoration,
          [decoration]: true,
        };
        return <DecorationAnnotation {...props} />;
      })}
    </DecorationContainer>
  ));
}

/****       NAME ANNOTATION ******/

export const Arrow = styled.div`
  width: 6px;
  height: 10px;
  position: absolute;
  top: calc(50% - 5px);
  left: -5px;
  overflow: hidden;
`;

export const BorderBlock = styled.div`
  width: 7px;
  height: 7px;
  transform: rotate(45deg);
  background-color: #dcaa4f;
  position: absolute;
  top: 1px;
  left: 2px;
`;

export const NameBorder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background-color: #dcaa4f;
`;

export const NameDecoration = styled.div`
  height: 100%;
  position: absolute;
  left: -5px;
  top: 0;
`;

function NameAnnotation({ annotation, children, isSelected }) {
  const name = annotation?.customData?.name;
  let offset = 0;
  console.log('BB ', annotation.boundingBox.left);
  if (annotation.boundingBox.left > 400) {
    offset = -200;
  }
  if (name) {
    return (
      <DecorationAnnotation $name>
        <NameDecoration>
          {isSelected && <SnippetName name={name} offset={offset} />}
          <Arrow>
            <BorderBlock />
          </Arrow>
          <NameBorder />
        </NameDecoration>
        {children}
      </DecorationAnnotation>
    );
  }

  return children;
}

/********  Link Annotation   *******/

export const LinkBorder = styled.div`
  width: 3px;
  height: 100%;
  content: '';
  position: absolute;
  right: -5px;
  top: 0;
  background-color: #0078d3;
`;

export const LinkWrapper = styled.div`
  position: absolute;
  right: 0;
  top: calc(50% + 2px);
  display: none;

  ${withModifiers('isSelected')`
      display: block;
    `}
`;

function LinkAnnotation({ children, isSelected, isLink }) {
  if (isLink) {
    return (
      <DecorationAnnotation $link>
        <LinkBorder />
        <LinkWrapper
          className="Cortlex-Linking-Wrapper"
          isSelected={isSelected}></LinkWrapper>
        {children}
      </DecorationAnnotation>
    );
  }

  return children;
}

/****** Global link counter *****/

export const BlueBubble = styled.div`
  width: 25px;
  height: 25px;
  background-color: #0078d3;
  border-radius: 100%;
  line-height: 25px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  position: relative;
  cursor: pointer;
  z-index: 2;
  left: 36px;
  top: -40px;
`;

const BubbleTail = styled(TailSVG)`
  height: 55px;
  position: absolute;
  top: -40px;
  left: -46px;
  pointer-events: none;
  transform: scale(0.5);
`;

export const GLOBAL_LINK_COUNTER_PREFIX = 'global-link-counter-';

export function getGlobalLinkCounterId(annotation?: any): string {
  const { annotationId } = annotation?.customData || {};

  return GLOBAL_LINK_COUNTER_PREFIX + annotationId;
}

export function GlobalLinkCounter({ annotation, count }) {
  return (
    <>
      <BlueBubble id={getGlobalLinkCounterId(annotation)}>{count}</BlueBubble>
      <BubbleTail />
    </>
  );
}

export function Annotation2({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
  parentNode,
  isSelected,
  annotation,
  isLink,
}) {
  return <Wrapper2>TEXT22</Wrapper2>;
}

export const Wrapper2 = styled.div`
  position: absolute;

  margin: 0px -120px;
  width: 200px;
  height: 100px;
  z-index: 999999999999;
  background-color: red;
  border: solid black 1px;
`;

export default function Annotation({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
  parentNode,
  isSelected,
  annotation,
  isLink,
}) {
  const { decorations = [] /*, annotationId*/ } = annotation?.customData || {};
  /*parentNode.addEventListener('click', (event) => {
    if(event.target.id === getGlobalLinkCounterId(annotationId)) {
      console.log("bubble");
    }
  })*/

  console.log('PARENT', parentNode);

  return (
    <>
      <Wrapper
        $isSelected={isSelected}
        data-custom-annotation-id={annotation.id}
        data-decorations={decorations.join(',')}>
        <LinkAnnotation isLink={isLink} isSelected={isSelected}>
          <NameAnnotation isSelected={isSelected} annotation={annotation}>
            <DecorationAnnotations annotation={annotation} />
          </NameAnnotation>
        </LinkAnnotation>
      </Wrapper>
    </>
  );
}
